import styles from './AppFooter.module.css';

export default function AppFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <p className={styles.copy}>CMPMaster · v1.0.0</p>
      </div>
    </footer>
  );
}
